import React from 'react'
import {Link}  from 'react-router-dom'
import './style.css'

const Footer = (props) =>{

    const ClickHandler = () =>{
        window.scrollTo(10, 0);
     }

  return(
    <footer className={`wpo-site-footer ${props.ftClass}`}>
        <div className="wpo-upper-footer">
            <div className="container">
                <div className="row">
                    <div className="col col-lg-3 col-md-6 col-12">
                        <div className="widget about-widget">
                            <div className="logo widget-title">
                                <img src={props.ftLogo} alt="blog"/>
                            </div>
                            <p>Build and Earn with your online store with lots of cool and exclusive wpo-features </p>
                        </div>
                    </div>
                    <div className="col col-lg-3 col-md-6 col-12">
                        <div className="widget link-widget resource-widget">
                            <div className="widget-title">
                                <h3>Resources</h3>
                            </div>
                            <ul>
                                <li><Link onClick={ClickHandler} to="/">Home</Link></li>
                                <li><Link onClick={ClickHandler} to="#services">Services</Link></li>
                                <li><Link onClick={ClickHandler} to="#packages">Packages</Link></li>
                                <li><Link onClick={ClickHandler} to="#about">About</Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col col-lg-3 col-md-6 col-12">
                        <div className="widget link-widget">
                            <div className="widget-title">
                                <h3>Useful Links</h3>
                            </div>
                            <ul>
                                <li><Link onClick={ClickHandler} to="/service-single">Disclaimer</Link></li>
                                <li><Link onClick={ClickHandler} to="/about">Privacy Policy</Link></li>
                                <li><Link onClick={ClickHandler} to="/pricing">Refund Policy</Link></li>
                                <li><Link onClick={ClickHandler} to="/contact">Terms and Conditions</Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col col-lg-3 col-md-6 col-12">
                        <div className="widget market-widget wpo-service-link-widget">
                            <div className="widget-title">
                                <h3>Contact </h3>
                            </div>
                            <div className="contact-ft">
                                <ul>
                                    <li><i className="fi flaticon-phone"></i>+000123456789</li>
                                    <li><i className="fi flaticon-mail"></i>Hastium@gmail.com</li>
                                    <li><i className="fi flaticon-mail"></i>Time: 9:00 - 5:00</li>
                                    <li><i className="fi flaticon-pin"></i>28 Street, New York City, USA</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="wpo-lower-footer">
            <div className="container">
                <div className="row">
                    <div className="separator"></div>
                    <div className="col col-xs-12">
                        <p className="copyright">&copy; 2024 Hastium. All rights reserved</p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
  )
} 

export default Footer;